webpackJsonp([1],{

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(155),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3cc16e99",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(154),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(156),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(157),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 154:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-view"
  }, [(_vm.activeView === 'data') ? _c('div', {
    attrs: {
      "id": "visualization"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : (_vm.activeView === 'json') ? _c('div', {
    staticClass: "result-view",
    attrs: {
      "id": "json"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.result))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rowChartDataTable"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Number of Sales per Property Type")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "rowChart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Latest Property Sale")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dataGrid"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Average Price Paid per Year")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "barChart"
    }
  })])
}]}

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "google-map",
    attrs: {
      "id": "gmap"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sparql-console"
  }, [_c('codemirror', {
    attrs: {
      "id": "codemirror",
      "options": _vm.editorOption
    },
    on: {
      "changes": _vm.onEditorChanges,
      "beforeChange": _vm.onEditorBeforeChange,
      "beforeSelectionChange": _vm.onEditorBeforeSelectionChange
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-fab"
  }, [_c('md-button', {
    staticClass: "md-fab md-primary",
    on: {
      "click": _vm.runQuery
    }
  }, [_c('md-icon', [_vm._v("play_arrow")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea')
},staticRenderFns: []}

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', [_c('md-input-container', [_c('label', [_vm._v("Postcode")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.selectedPostcode),
      callback: function($$v) {
        _vm.selectedPostcode = $$v
      },
      expression: "selectedPostcode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [(_vm.currentView === 'map') ? _c('div', [_c('GoogleMap', {
    ref: "gmap",
    attrs: {
      "id": "gmap"
    }
  })], 1) : (_vm.currentView === 'query') ? _c('div', [_c('SparqlConsole', {
    attrs: {
      "id": "console"
    },
    on: {
      "runQuery": _vm.runQuery
    }
  })], 1) : _c('div', [_c('ResultView', {
    attrs: {
      "id": "result"
    }
  })], 1)]), _vm._v(" "), _c('md-bottom-bar', [_c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "map",
      "id": "map-button",
      "md-active": ""
    },
    on: {
      "click": function($event) {
        _vm.currentView = 'map'
      }
    }
  }, [_vm._v("Map")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "code",
      "id": "query-button"
    },
    on: {
      "click": function($event) {
        _vm.currentView = 'query'
      }
    }
  }, [_vm._v("Query")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "equalizer",
      "id": "result-button"
    },
    on: {
      "click": _vm.runQuery
    }
  }, [_vm._v("Result")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(158),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_codemirror__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_codemirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_codemirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
// Required for IE11

__WEBPACK_IMPORTED_MODULE_0_es6_promise___default.a.polyfill();

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_codemirror___default.a);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    postcode: '',
    queryPrefix: 'prefix xsd: <http://www.w3.org/2001/XMLSchema#>\n' + 'prefix ukhpi: <http://landregistry.data.gov.uk/def/ukhpi/>\n' + 'prefix lrppi: <http://landregistry.data.gov.uk/def/ppi/>\n' + 'prefix skos: <http://www.w3.org/2004/02/skos/core#>\n' + 'prefix lrcommon: <http://landregistry.data.gov.uk/def/common/>\n' + '\n' + 'SELECT ?paon ?saon ?street ?town ?county ?propertyType ?postcode ?amount ?date ?category\n' + 'WHERE\n' + '{\n' + '  VALUES ?postcode {"',
    queryPostfix: '"^^xsd:string}\n' + '\n' + '  ?addr lrcommon:postcode ?postcode.\n' + '\n' + '  ?transx lrppi:propertyAddress ?addr ;\n' + '  lrppi:pricePaid ?amount ;\n' + '  lrppi:propertyType/skos:prefLabel ?propertyType ;\n' + '  lrppi:transactionDate ?date ;\n' + '  lrppi:transactionCategory/skos:prefLabel ?category.\n' + '\n' + '  OPTIONAL {?addr lrcommon:county ?county}\n' + '  OPTIONAL {?addr lrcommon:paon ?paon}\n' + '  OPTIONAL {?addr lrcommon:saon ?saon}\n' + '  OPTIONAL {?addr lrcommon:street ?street}\n' + '  OPTIONAL {?addr lrcommon:town ?town}\n' + '}',
    queryResult: {},
    queryStatusCode: 0
  },
  mutations: {
    updatePostcode: function updatePostcode(state, postcode) {
      state.postcode = postcode;
    },
    updateQueryResult: function updateQueryResult(state, result) {
      state.queryResult = result;
    },
    updateQueryStatusCode: function updateQueryStatusCode(state, status) {
      state.queryStatusCode = status;
    },
    updateQueryPrefix: function updateQueryPrefix(state, queryPrefix) {
      state.queryPrefix = queryPrefix;
    },
    updateQueryPostfix: function updateQueryPostfix(state, queryPostfix) {
      state.queryPostfix = queryPostfix;
    }
  },
  getters: {
    code: function code(state) {
      return state.queryPrefix + state.postcode + state.queryPostfix;
    },
    queryResult: function queryResult(state) {
      return state.queryResult;
    }
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

//
//
//
//

window.CodeMirror = __webpack_require__(13);
__webpack_require__(140);
__webpack_require__(43);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'codemirror',
  data: function data() {
    return {
      content: ''
    };
  },
  props: {
    code: String,
    value: String,
    unseenLines: Array,
    marker: Function,
    loadtheme: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    debugger: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    options: {
      type: Object,
      required: true
    }
  },
  created: function created() {

    if (this.options.lineNumbers === undefined) {
      this.options.lineNumbers = true;
    }
    if (this.options.lineWrapping === undefined) {
      this.options.lineWrapping = false;
    }
    if (this.options.mode === undefined) {
      this.options.mode = 'text/javascript';
    }

    var theme = this.options.theme;
    var language = this.options.mode;
    var _debugger = this.debugger;
    var _loadtheme = this.loadtheme;
    var isCustomMode = !!CodeMirror.modes[language];

    // theme config
    if (theme && theme == 'solarized light') {
      theme = 'solarized';
    }

    // console.log(language, CodeMirror.modes.simplemode)

    // language string config
    if (typeof language == 'string') {
      var lang = CodeMirror.findModeByMIME(language);
      language = !lang ? lang : lang.mode;

      // language object config
    } else if ((typeof language === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(language)) == 'object') {

      if (language.name) {
        var lang = CodeMirror.findModeByName(language.name);
        if (lang) {
          language = lang.mode;
          // this.options.mode = language
        } else {
          language = null;
        }
      } else if (language.ext) {
        var lang = CodeMirror.findModeByExtension(language.ext);
        if (lang) {
          language = lang.mode;
          // this.options.mode = language
        } else {
          language = null;
        }
      } else if (language.mime) {
        var lang = CodeMirror.findModeByMIME(language.mime);
        if (lang) {
          language = lang.mode;
          // this.options.mode = language
        } else {
          language = null;
        }
      } else if (language.filename) {
        var lang = CodeMirror.findModeByFileName(language.filename);
        if (lang) {
          language = lang.mode;
          // this.options.mode = language
        } else {
          language = null;
        }
      }
    }

    // console.log('language', language, isCustomMode)

    if ((!language || language == 'null') && _debugger && !isCustomMode) {
      console.warn('CodeMirror language mode: ' + language + ' configuration error (CodeMirror语言模式配置错误，或者不支持此语言) See http://codemirror.net/mode/ for more details.');
      // return false
    }

    // console.log(language, theme)

    // require language
    if (language && language !== 'null') {
      __webpack_require__(95)("./" + language + '/' + language + '.js');
    }

    // require theme
    if (theme && _loadtheme) {
      __webpack_require__(97)("./" + theme + '.css');
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.editor = CodeMirror.fromTextArea(this.$el, this.options);
    this.editor.setValue(this.code || this.value || this.content);
    this.editor.on('change', function (cm) {
      _this.content = cm.getValue();
      if (!!_this.$emit) {
        _this.$emit('change', _this.content);
        _this.$emit('input', _this.content);
      }
    });
    var events = ['changes', 'beforeChange', 'cursorActivity', 'keyHandled', 'inputRead', 'electricInput', 'beforeSelectionChange', 'viewportChange', 'swapDoc', 'gutterClick', 'gutterContextMenu', 'focus', 'blur', 'refresh', 'optionChange', 'scrollCursorIntoView', 'update'];
    for (var i = events.length - 1; i >= 0; i--) {
      (function (event) {
        _this.editor.on(event, function (a, b, c) {
          _this.$emit(event, a, b, c);
        });
      })(events[i]);
    }
    this.$emit('ready', this.editor);
    this.unseenLineMarkers();

    // prevents funky dynamic rendering
    window.setTimeout(function () {
      _this.editor.refresh();
    }, 0);
  },
  beforeDestroy: function beforeDestroy() {

    // garbage cleanup
    var element = this.editor.doc.cm.getWrapperElement();
    if (element && element.remove) {
      element.remove();
    }
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(options, oldOptions) {
        var key;
        for (key in options) {
          this.editor.setOption(key, options[key]);
        }
      }
    },
    code: function code(newVal, oldVal) {
      var editor_value = this.editor.getValue();
      if (newVal !== editor_value) {
        var scrollInfo = this.editor.getScrollInfo();
        this.editor.setValue(newVal);
        this.content = newVal;
        this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
      }
      this.unseenLineMarkers();
    },
    value: function value(newVal, oldVal) {
      var editor_value = this.editor.getValue();
      if (newVal !== editor_value) {
        var scrollInfo = this.editor.getScrollInfo();
        this.editor.setValue(newVal);
        this.content = newVal;
        this.editor.scrollTo(scrollInfo.left, scrollInfo.top);
      }
      this.unseenLineMarkers();
    }
  },
  methods: {
    refresh: function refresh() {
      this.editor.refresh();
    },
    unseenLineMarkers: function unseenLineMarkers() {
      var _this = this;
      if (_this.unseenLines !== undefined && _this.marker !== undefined) {
        _this.unseenLines.forEach(function (line) {
          var info = _this.editor.lineInfo(line);
          _this.editor.setGutterMarker(line, "breakpoints", info.gutterMarkers ? null : _this.marker());
        });
      }
    }
  }
});

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GoogleMap__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GoogleMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_GoogleMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SparqlConsole__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SparqlConsole___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SparqlConsole__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ResultView__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ResultView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ResultView__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__(37);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      currentView: 'map'
    };
  },

  components: {
    GoogleMap: __WEBPACK_IMPORTED_MODULE_1__components_GoogleMap___default.a,
    SparqlConsole: __WEBPACK_IMPORTED_MODULE_2__components_SparqlConsole___default.a,
    ResultView: __WEBPACK_IMPORTED_MODULE_3__components_ResultView___default.a
  },
  methods: {
    // Opens the result tab by clicking on the bottom menu item
    openResult: function openResult() {
      var resultButton = document.getElementById('result-button');
      resultButton.click();
    },
    // Runs the query found in sparql console and updates Vuex state of the response code and the response itself
    runQuery: function runQuery() {
      var mVue = this;
      var url = 'http://landregistry.data.gov.uk/landregistry/query?query=' + encodeURIComponent(mVue.code);
      axios.get(url, {
        headers: {
          'Accept': 'application/sparql-results+json'
        }
      }).then(function (response) {
        var data = mVue.parseQueryResult(response.data.results.bindings);
        mVue.$store.commit('updateQueryStatusCode', response.status);
        mVue.$store.commit('updateQueryResult', data);
      }).catch(function (error) {
        if (error) {
          mVue.$store.commit('updateQueryStatusCode', error.response.status);
          mVue.$store.commit('updateQueryResult', error.response.data);
        }
      });
    },
    // Strips down sparql query result to a simple json form
    parseQueryResult: function parseQueryResult(result) {
      var mVue = this;
      return result.map(function (row) {
        var rowObject = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).forEach(function (column) {
          rowObject[column] = mVue.dataTypeCast(row[column]);
        });
        return rowObject;
      });
    },
    // Casts an object value into a corresponding data type found in the object properties
    dataTypeCast: function dataTypeCast(obj) {
      var xmlSchema = 'http://www.w3.org/2001/XMLSchema#';
      var value = obj.value;
      if (typeof obj.datatype === 'undefined') {
        return value;
      }
      var dataType = obj.datatype.replace(xmlSchema, '');
      switch (dataType) {
        case 'string':
          value = new String(value); // eslint-disable-line
          break;
        case 'boolean':
          value = new Boolean(value === 'false' ? false : value); // eslint-disable-line
          break;
        case 'float':
        case 'integer':
        case 'long':
        case 'double':
        case 'decimal':
        case 'nonPositiveInteger':
        case 'nonNegativeInteger':
        case 'negativeInteger':
        case 'int':
        case 'unsignedLong':
        case 'positiveInteger':
        case 'short':
        case 'unsignedInt':
        case 'byte':
        case 'unsignedShort':
        case 'unsignedByte':
          value = new Number(value); // eslint-disable-line
          break;
        case 'date':
        case 'time':
        case 'dateTime':
          value = new Date(value);
          break;
      }
      return value;
    }
  },
  computed: {
    selectedPostcode: {
      get: function get() {
        return this.$store.state.postcode;
      },
      set: function set(newPostcode) {
        this.$store.commit('updatePostcode', newPostcode);
      }
    },
    queryResult: {
      get: function get() {
        return this.$store.state.queryResult;
      }
    },
    code: {
      get: function get() {
        return this.$store.getters.code;
      }
    }
  },
  watch: {
    // As soon as the state of queryResult is updated open the results view
    queryResult: function queryResult() {
      this.currentView = 'result';
    }
  }
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

var chroma = __webpack_require__(94);
var turf = __webpack_require__(62);
var turfInside = __webpack_require__(63);
var d3voronoi = __webpack_require__(134);
var axios = __webpack_require__(37);
var Promise = __webpack_require__(93);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'google-map',
  data: function data() {
    return {
      visiblePostcodes: [],
      map: {},
      mapCenter: new window.google.maps.LatLng(51.46040383078197, -2.6015971891367826),
      infoWindow: new window.google.maps.InfoWindow(),
      populatingData: false
    };
  },
  mounted: function mounted() {
    this.updateMapCenter();
    var mVue = this;
    var element = document.getElementById('gmap');
    var options = {
      zoom: 17,
      center: this.mapCenter,
      disableDefaultUI: true,
      zoomControl: true,
      minZoom: 17,
      maxZoom: 18
    };
    var map = new window.google.maps.Map(element, options);
    // Map on idle listener updates the data layer
    map.addListener('idle', function () {
      if (!mVue.populatingData) {
        mVue.mapCenter = map.getCenter();
        mVue.getNearbyPostcodes();
      }
    });
    mVue.map = map;
  },

  methods: {
    // Updates the map center to match the given postcode centroid
    updateMapCenter: function updateMapCenter() {
      var _this = this;

      if (this.postcode.length < 6) return;
      var url = 'https://api.postcodes.io/postcodes/' + this.postcode;
      return axios.get(url).then(function (response) {
        _this.mapCenter = new window.google.maps.LatLng(response.data.result.latitude, response.data.result.longitude);
      }).catch(function (error) {
        console.log(error);
      });
    },
    // Updates a list of visible postcodes with geoJSON points representing postcode centroids which are returned from the API call
    getNearbyPostcodes: function getNearbyPostcodes() {
      var _this2 = this;

      this.visiblePostcodes = [];
      var url = 'https://api.postcodes.io/postcodes?lon=' + this.mapCenter.lng() + '&lat=' + this.mapCenter.lat() + '&radius=300&limit=99';
      axios.get(url).then(function (response) {
        response.data.result.forEach(function (result) {
          var postcode = turf.point([result.longitude, result.latitude]);
          postcode.id = result.postcode;
          _this2.visiblePostcodes.push(postcode);
        });
      }).then(function () {
        _this2.populateURLs();
      }).catch(function (error) {
        console.log(error);
      });
    },
    // Loops through visiblePostcodes and generates an url for querying the land registry api
    populateURLs: function populateURLs() {
      this.visiblePostcodes.forEach(function (postcode) {
        var url = 'http://landregistry.data.gov.uk/data/ppi/transaction-record.json?_page=0&propertyAddress.postcode=' + postcode.id + '&_pageSize=50';
        url = url.replace(' ', '%20');
        postcode.properties.url = url;
      });
      this.getData();
    },
    // Runs an API call for all visible postcodes and calculates the average price paid
    getData: function getData() {
      var _this3 = this;

      Promise.map(this.visiblePostcodes, function (postcode) {
        return axios.get(postcode.properties.url).then(function (response) {
          var totalPaid = 0;
          var data = response.data.result.items;
          data.forEach(function (transaction) {
            totalPaid += transaction.pricePaid;
          });
          postcode.properties.averagePaid = totalPaid ? totalPaid / data.length : 0;
        }).catch(function (error) {
          console.log(error);
        });
      }, { concurrency: 10 }).then(function () {
        _this3.generateVoronoi();
      });
    },
    // Given a set of postcode centroids it creates a set of approximated postcode boundaries using a voronoi algorithm
    generateVoronoi: function generateVoronoi() {
      var _this4 = this;

      var centroids = [];
      this.visiblePostcodes.forEach(function (postcode) {
        centroids.push(postcode.geometry.coordinates);
      });

      var maxY = this.map.getBounds().getNorthEast().lat() + 0.005;
      var maxX = this.map.getBounds().getNorthEast().lng() + 0.005;
      var minY = this.map.getBounds().getSouthWest().lat() - 0.005;
      var minX = this.map.getBounds().getSouthWest().lng() - 0.005;

      var voronoi = d3voronoi.voronoi().extent([[minX, minY], [maxX, maxY]]);
      var voronoiPolygons = voronoi(centroids).polygons();

      var postcodePolygons = [];
      voronoiPolygons.forEach(function (polygon) {
        // Reverse coordinate order so it conforms to the right-hand rule.
        // Close the ring by making the last position the same as the first.
        polygon.reverse().push(polygon[0]);
        var postcodePolygon = turf.polygon([polygon]);
        _this4.visiblePostcodes.forEach(function (postcodePoint) {
          if (turfInside(postcodePoint, postcodePolygon)) {
            postcodePolygon.id = postcodePoint.id;
            postcodePolygon.properties = postcodePoint.properties;
            postcodePolygon.properties.centroid = postcodePoint.geometry.coordinates;
          }
        });
        postcodePolygons.push(postcodePolygon);
      });
      this.clearShapes();
      this.visiblePostcodes = postcodePolygons;
      this.populateData();
    },
    // Removes all the features from the map data layer
    clearShapes: function clearShapes() {
      var _this5 = this;

      this.map.data.forEach(function (feature) {
        _this5.map.data.remove(feature);
      });
      this.visiblePostcodes = [];
    },
    // Populates the map data layer with the visiblePostcode polygons
    populateData: function populateData() {
      var _this6 = this;

      var min = Infinity;
      var max = -Infinity;
      this.visiblePostcodes.forEach(function (postcode) {
        _this6.map.data.addGeoJson(postcode);
        if (postcode.properties.averagePaid > max) max = postcode.properties.averagePaid;
        if (postcode.properties.averagePaid < min) min = postcode.properties.averagePaid;
      });
      this.setPolygonsColor(min, max);
    },
    // Colors the polygons based on the average price paid
    setPolygonsColor: function setPolygonsColor(min, max) {
      var bezInterpolator = chroma.scale(['#E8FF3C', '#FF4500', '#D90000']);
      this.map.data.setStyle(function (feature) {
        var avgPaid = feature.getProperty('averagePaid');
        var colorIndex = (avgPaid - min) / (max - min);
        var color = avgPaid ? bezInterpolator(colorIndex) : '#ffffff';
        return {
          fillColor: color,
          strokeWeight: 1
        };
      });
      this.setOnFeatureClickListener();
    },
    // Sets a map data on click listener to open an info window
    setOnFeatureClickListener: function setOnFeatureClickListener() {
      var mVue = this;
      this.map.data.addListener('click', function (event) {
        if (mVue.infoWindow) {
          mVue.infoWindow.close();
        }
        var centroid = event.feature.getProperty('centroid');
        var averagePricePaid = mVue.prettyPrintCurrency(event.feature.getProperty('averagePaid'));
        var message = '<p><b>' + event.feature.getId() + '</b></p>' + ('<p>Average Price Paid: ' + averagePricePaid + '</p>');
        mVue.infoWindow = new window.google.maps.InfoWindow({
          content: message,
          position: new window.google.maps.LatLng(centroid[1], centroid[0])
        });
        mVue.postcode = event.feature.getId();
        mVue.infoWindow.open(mVue.map);
      });
      this.populatingData = false;
    },
    // Converts a number into a currency string
    prettyPrintCurrency: function prettyPrintCurrency(amount) {
      return amount.toLocaleString('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 2 });
    }
  },
  computed: {
    postcode: {
      get: function get() {
        return this.$store.state.postcode;
      },
      set: function set(newPostcode) {
        this.$store.commit('updatePostcode', newPostcode);
      }
    }
  },
  watch: {
    // When mapCenter is updated set the map camera to the new location
    mapCenter: function mapCenter() {
      this.map.panTo(this.mapCenter);
    },
    // If the updated postcode is of at least the mimimum postcode length update the data layer
    postcode: function postcode(newPostcode) {
      var _this7 = this;

      if (newPostcode.length > 5) {
        this.populatingData = true;
        this.updateMapCenter().then(function () {
          _this7.getNearbyPostcodes();
        });
      }
    }
  }
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var dc = __webpack_require__(139);
var d3 = __webpack_require__(56);
var crossfilter = __webpack_require__(131);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      result: this.$store.state.queryResult,
      statusCode: this.$store.state.queryStatusCode,
      message: '',
      requiredFields: ['paon', 'street', 'town', 'county', 'propertyType', 'postcode', 'amount', 'date'],
      activeView: 'data'
    };
  },
  mounted: function mounted() {
    var mVue = this;
    if (this.statusCode > 399) {
      this.message = '';
      this.activeView = 'json';
      return;
    } else if (this.result.length === 0) {
      this.message = 'No sales in ' + this.postcode + ' since 01/01/1995';
      this.activeView = 'json';
    } else {
      var hasAllRequiredFields = this.requiredFields.every(function (field) {
        return mVue.result[0].hasOwnProperty(field);
      });
      if (!hasAllRequiredFields) {
        this.message = 'To visualize the data please return all of the following fields:\n' + 'paon, street, town, county, propertyType, postcode, amount, date\n\n' + 'Query Result as JSON:';
        this.activeView = 'json';
      } else {
        this.visualizeData();
      }
    }
  },

  methods: {
    // Visualises the data using dc.js and crossfilter
    // See: https://dc-js.github.io/dc.js/
    visualizeData: function visualizeData() {
      var rowChart = dc.rowChart('#rowChart');
      var barChart = dc.barChart('#barChart');
      var dataGrid = dc.dataGrid('#dataGrid');

      var ndx = crossfilter(this.result);

      var propertyTypeDimension = ndx.dimension(function (d) {
        return d.propertyType;
      });
      var propertyTypeGroup = propertyTypeDimension.group().reduceCount(function (d) {
        return d.amount;
      });
      var yearDimension = ndx.dimension(function (d) {
        return d.date.toString().substring(11, 15);
      });
      var yearAvgGroup = yearDimension.group().reduce(
      /* callback for when data is added to the current filter results */
      function (p, v) {
        ++p.count;
        p.total += v.amount;
        p.average = p.count ? p.total / p.count : 0;
        return p;
      },
      /* callback for when data is removed from the current filter results */
      function (p, v) {
        --p.count;
        p.total -= v.amount;
        p.average = p.count ? p.total / p.count : 0;
        return p;
      },
      /* initialize p */
      function () {
        return {
          count: 0,
          total: 0,
          average: 0
        };
      });

      var timeDimension = ndx.dimension(function (d) {
        return d.date.getTime();
      });

      var yearDomain = [];
      for (var i = 1995; i < 2018; i++) {
        yearDomain.push(i.toString());
      }

      rowChart.width(260).height(200).group(propertyTypeGroup).dimension(propertyTypeDimension).ordinalColors(['#005E00', '#0F8500', '#35AB17', '#5BD13D', '#81F763']).title(function (d) {
        return d.propertyType;
      }).elasticX(true).turnOnControls(true);

      rowChart.xAxis().ticks(5).tickSize(2).tickPadding(10);

      barChart.width(500).height(215).dimension(yearDimension).group(yearAvgGroup).valueAccessor(function (p) {
        return p.value.average;
      }).x(d3.scale.ordinal().domain(yearDomain)).xUnits(dc.units.ordinal).elasticY(true).yAxisLabel('').elasticX(true).xAxisLabel('Year').renderHorizontalGridLines(true).gap(1).centerBar(false).margins({ top: 10, right: 0, bottom: 45, left: 65 });

      barChart.xAxis().tickFormat(function (d) {
        return '\'' + d.substring(2, 4);
      }).tickSize(2).tickPadding(10);

      barChart.yAxis().tickFormat(function (d) {
        return d.toLocaleString('en-GB', {
          style: 'currency',
          currency: 'GBP',
          maximumFractionDigits: 0,
          minimumFractionDigits: 0
        });
      }).tickSize(2);

      dataGrid.dimension(timeDimension).group(function (d) {
        return d.propertyType;
      }).html(function (d) {
        var html = '<div><b>Address:</b> ' + d.paon + ' ' + d.street + '</div>' + ('<div><b>Town:</b> ' + d.town + '</div>') + ('<div><b>County:</b> ' + d.county + '</div>') + ('<div><b>Property Type:</b> ' + d.propertyType + '</div>') + ('<div><b>Price Paid:</b> ' + d.amount.toLocaleString('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 2 }) + '</div>') + ('<div><b>Date:</b> ' + d.date.getDate() + '/' + (d.date.getMonth() + 1) + '/' + d.date.getFullYear() + '</div>');
        return html;
      }).sortBy(function (d) {
        return d.date.getTime();
      }).size(1);

      dc.renderAll();
    }
  },
  computed: {
    postcode: {
      get: function get() {
        return this.$store.state.postcode;
      },
      set: function set(newPostcode) {
        this.$store.commit('updatePostcode', newPostcode);
      }
    }
  }
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      editorOption: {
        inputStyle: 'contenteditable',
        tabSize: 2,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        matchBrackets: true,
        mode: 'application/sparql-query',
        theme: 'base16-light'
      }
    };
  },

  methods: {
    // Prforms a click on a result button in bottom navigation
    runQuery: function runQuery() {
      var resultButton = document.getElementById('result-button');
      resultButton.click();
    },
    // Returns the string index given a line and character number
    getIndexAt: function getIndexAt(string, line, char) {
      var currentLine = 0;
      for (var x = 0; x < string.length; x++) {
        if (string[x] === '\n') {
          currentLine++;
          continue;
        }
        if (currentLine === line) {
          return x + char;
        }
      }
    },
    // Cancels every selection made in the code by forcing the head to equal the anchor
    onEditorBeforeSelectionChange: function onEditorBeforeSelectionChange(codemirror, changeObject) {
      var ranges = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(changeObject.ranges));
      ranges[0].head = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(changeObject.ranges[0].anchor));
      changeObject.update(ranges);
    },
    // Cancels every change that is not a single character input or delete or an external value update
    onEditorBeforeChange: function onEditorBeforeChange(codemirror, changeObject) {
      if (changeObject.origin !== '+delete' && changeObject.origin !== '+input' && changeObject.origin !== 'setValue') {
        changeObject.cancel();
      }
    },
    // Updates queryPrefix, queryPostfix or postcode based on the changes user makes inside the console
    onEditorChanges: function onEditorChanges(codemirror, changeObjects) {
      var newEditorState = codemirror.getValue();
      var postcodeStartIndex = this.queryPrefix.length;
      var postcodeEndIndex = postcodeStartIndex + this.postcode.length;
      for (var i = 0; i < changeObjects.length; i++) {
        var changeObject = changeObjects[i];
        var changedCharIndex = this.getIndexAt(codemirror.getValue(), changeObject.from.line, changeObject.from.ch);
        if (changeObject.origin === '+delete') {
          if (changedCharIndex < postcodeStartIndex) {
            // Change in query prefix
            this.queryPrefix = newEditorState.substring(0, postcodeStartIndex - 1);
          } else if (changedCharIndex < postcodeEndIndex) {
            // Change in the postcode
            this.postcode = newEditorState.substring(postcodeStartIndex, postcodeEndIndex - 1);
          } else {
            // Change in query postfix
            this.queryPostfix = newEditorState.substring(postcodeEndIndex, newEditorState.length);
          }
        } else if (changeObject.origin === '+input') {
          if (changedCharIndex < postcodeStartIndex) {
            // Change in query prefix
            this.queryPrefix = newEditorState.substring(0, postcodeStartIndex + 1);
          } else if (changedCharIndex <= postcodeEndIndex) {
            // Change in the postcode
            this.postcode = newEditorState.substring(postcodeStartIndex, postcodeEndIndex + 1);
          } else {
            // Change in query postfix
            this.queryPostfix = newEditorState.substring(postcodeEndIndex, newEditorState.length);
          }
        }
      }
    }
  },
  computed: {
    postcode: {
      get: function get() {
        return this.$store.state.postcode;
      },
      set: function set(newPostcode) {
        this.$store.commit('updatePostcode', newPostcode);
      }
    },
    code: {
      get: function get() {
        return this.$store.getters.code;
      }
    },
    queryPrefix: {
      get: function get() {
        return this.$store.state.queryPrefix;
      },
      set: function set(newQueryPrefix) {
        this.$store.commit('updateQueryPrefix', newQueryPrefix);
      }
    },
    queryPostfix: {
      get: function get() {
        return this.$store.state.queryPostfix;
      },
      set: function set(newQueryPostfix) {
        this.$store.commit('updateQueryPostfix', newQueryPostfix);
      }
    }
  }
});

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./meta.js": 43,
	"./sparql/sparql.js": 96
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./base16-dark.css": 141,
	"./base16-light.css": 142
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;

/***/ })

},[82]);


// WEBPACK FOOTER //
// static/js/app.76843489fb92a9c5f188.js